// @ts-nocheck
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import Minus from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus from "@store/Library/Components/Toolkit/Icons/Plus";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

const borderRadius = pxToRem(8);

const _headerButtonBaseStyles = () => {
    return css`
        background-color: ${getColor("common.accent")};
        color: ${getColor("text.main")};
        border: ${pxToRem(1)} solid ${getColor("common.border")};
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

        &[aria-expanded="false"],
        &[aria-expanded="false"]:focus,
        &[aria-expanded="false"]:focus-visible {
            border-bottom-left-radius: ${borderRadius};
            border-bottom-right-radius: ${borderRadius};
        }

        &[aria-expanded="true"] {
            background-color: ${getColor("common.accent")};
            border-color: ${getColor("common.border")};
            border-bottom: none;
            color: ${getColor("text.main")};
        }

        &:hover {
            background-color: ${getColor("common.accent")};
            color: ${getColor("primary.main")};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
                border-color: ${getColor("common.border")};
            }
        }
    `;
};

export const accordionInfoSectionProps: AccordionSectionPresentationProps = {
    expandIconProps: { src: Plus, size: 20 },
    collapseIconProps: { src: Minus, size: 20 },
    headerProps: {
        css: css`
            ${_headerButtonStyles()}
        `,
    },
    panelProps: {
        css: css`
            padding: 0;
            border: ${pxToRem(1)} solid ${getColor("common.border")};
            border-top: none;
            border-bottom-left-radius: ${borderRadius};
            border-bottom-right-radius: ${borderRadius};
        `,
    },
};
